export const FREE_QUESTION =
  'What does my birth chart reveal about my true personality and natural traits?';

export const questionTemplates = {
  Marriage: [
    'When will I get Married?',
    'Love marriage or arrange?',
    'Will there be any delay in my marriage?',
    'Will I marry the person I love?',
    'What is the most favorable time for me to get married?',
    'Do I have any doshas that could affect my marriage?',
  ],
  Career: [
    'What is the best job role for me?',
    'Will I get a promotion this year?',
    'Is a job change favorable now?',
    'Will I settle abroad for work?',
  ],
  Finance: [
    'How will my financial situation be this year?',
    'Will I recover from my debts?',
    'Is investing in stocks good for me?',
    'Will I buy a house soon?',
  ],
  Foreign: ['Will I get a job in USA?'],
};
